import styled from "styled-components";
import { TextColorNames } from "@smartsuite/types";

export const StyledReactInputFieldContainer = styled.div`
  padding: 0 0px 14px;
  position: relative;
`;

export const StyledInputLabel = styled.label`
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 18px;
  display: inline-flex;
  align-items: center;
  padding-right: 1px;
  color: ${TextColorNames.primary};
`;

export const StyledInputSubLabel = styled.label`
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  display: flex;
  align-items: center;
  color: ${TextColorNames.secondary};
  margin-bottom: 9px;

  b {
    color: ${TextColorNames.primary};
  }

  a,
  a:visited {
    color: ${TextColorNames.secondary};
  }
`;
